import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { CamarasService } from '../../../auxiliares/servicios/http/camara.service';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { CardHeaderComponent } from '../../../componentes/card-header/card-header.component';
import { SectionTitleComponent } from '../../../componentes/section-title/section-title.component';
import { DescargasModule } from '../../navigation/descargas/module';
import { DescargasService } from '../../navigation/descargas/service';

export interface IDescargarVideoCamaraData {
  idCamara: string;
  nombreCamara: string;
}

@Component({
  imports: [
    AuxiliaresModule,
    InfoBannerComponent,
    CardHeaderComponent,
    SectionTitleComponent,
    DescargasModule,
  ],
  selector: 'app-descargar-video-camara',
  templateUrl: './descargar-video-camara.component.html',
  styleUrl: './descargar-video-camara.component.scss',
})
export class DescargarVideoCamaraComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DescargarVideoCamaraComponent>>(MatDialogRef);
  data = inject<IDescargarVideoCamaraData>(MAT_DIALOG_DATA);
  helper = inject(HelperService);
  private camarasService = inject(CamarasService);
  private descargasService = inject(DescargasService);

  public loading = false;
  public form?: FormGroup;
  public title = 'Descargar Video';
  public maxDate = new Date();
  public maxDateString = this.formatDateTimeLocal(new Date());
  public minutos = 5;

  private formatDateTimeLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  private createForm() {
    this.form = new FormGroup({
      canal: new FormControl('0', [
        Validators.required,
        Validators.pattern(/^\d+$/),
      ]),
      fechaInicio: new FormControl(null, [Validators.required]),
      minutos: new FormControl(5, [
        Validators.required,
        Validators.min(1),
        Validators.max(15),
      ]),
    });
  }

  public async onSubmit() {
    if (!this.form?.valid) {
      this.helper.notifWarn('Completá todos los campos correctamente');
      return;
    }

    const fechaInicio = this.form.get('fechaInicio')?.value;
    if (!fechaInicio) {
      this.helper.notifWarn('Seleccioná una fecha de inicio');
      return;
    }

    this.loading = true;
    try {
      const canal = this.form.get('canal')?.value;
      const minutos = this.form.get('minutos')?.value;

      // Calcular fecha fin sumando los minutos
      const beginTime = new Date(fechaInicio).toISOString();
      const fechaFin = new Date(fechaInicio);
      fechaFin.setMinutes(fechaFin.getMinutes() + minutos);
      const endTime = fechaFin.toISOString();

      const result = await this.camarasService.downloadVideoTask(
        this.data.idCamara,
        canal,
        beginTime,
        endTime,
      );
      this.descargasService.agregarDescargaVideo(
        this.data.idCamara,
        result,
        `${this.data.nombreCamara} - Canal ${canal} (${minutos} min)`,
      );
      this.helper.notifSuccess('Descarga agregada a la cola');
      this.dialogRef.close();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public volver() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.createForm();
  }
}
